/**
 * StudentsConsents
 * show and edit consents for all children
 */
import React, { useEffect, useMemo } from 'react';
import { PropTypes } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Card, Alert, Table } from 'react-bootstrap';
import useCurrentRole from 'containers/User/useCurrentRole.js';
import Spinner from 'components/Spinner/index.jsx';
import { PARENT_ROLE } from 'containers/User/constants.js';
import Avatar from 'components/media/Avatar/index.jsx';
import InfoButton from 'components/interaction/InfoButton/index.jsx';
import UserText from 'components/media/UserText/Loadable.js';
import messages from './messages.js';
import useConsentItems from '../useConsentItems.js';
import consentItemsByCategory from '../consentItemsByCategory.js';
import ConsentControl from '../StudentConsentItems/ConsentControl.jsx';

function StudentsConsents(props) {
  const { setMeta } = props;
  const role = useCurrentRole();
  const { studentItems, loading, setConsent } = useConsentItems();
  const categories = useMemo(() => studentItems[0] && consentItemsByCategory(studentItems[0].items), [role, studentItems]);

  useEffect(() => {
    setMeta({ title: messages.title });
  }, []);

  function renderBody() {
    if (role.type !== PARENT_ROLE) {
      return <Alert variant="warning"><FormattedMessage {...messages.parentsOnly} /></Alert>;
    }
    if (loading) {
      return <Spinner />;
    }
    if (studentItems.length === 0) {
      return <Alert variant="info"><FormattedMessage {...messages.noStudents} /></Alert>;
    }
    return (
      <Table responsive>
        {categories?.map((cat, i) => (
          <tbody key={cat.id}>
            <tr className="align-bottom">
              <th className="pt-5">{cat.title}</th>
              {studentItems.map((item) => (
                <th key={item.id} className="text-center">
                  {i === 0 && (
                    <>
                      <Avatar src={item.student.avatar} />
                      <div>
                        {item.student.displayName}
                      </div>
                    </>
                  )}
                </th>
              ))}
            </tr>
            {cat.items.map((item) => (
              <tr key={item.id}>
                <td>
                  {item.title}
                  {item.description && <InfoButton><UserText>{item.description}</UserText></InfoButton>}
                </td>
                {studentItems.map((studentItem) => (
                  <td key={studentItem.id} className="text-center">
                    <ConsentControl item={studentItem.items[item.id]} onChange={(itemId, consent) => setConsent(studentItem.student.id, itemId, consent)} />
                  </td>
                ))}
              </tr>
            ))}

          </tbody>

        ))}
      </Table>
    );
  }

  return (
    <Card>
      <Card.Header className="border-0">
        <h2 className="card-title"><FormattedMessage {...messages.header} /></h2>
      </Card.Header>
      <Card.Body>
        {renderBody()}
      </Card.Body>
    </Card>

  );
}

StudentsConsents.propTypes = {
  setMeta: PropTypes.func.isRequired,
};

export default StudentsConsents;
